<template>
  <div style="padding: 24px;background: #fff;">
    <div class="search-bar">
      <a-row type="flex" justify="start" align="middle">
        <a-col :span="6">
          <a-input-search placeholder="输入菜品名称查询" v-model="keyword" @search="onSearch" enterButton/>
        </a-col>
        <a-col :span="18">
          <a-button type="primary" @click="showAddDrawers" style="float:right">
            <a-icon type="plus"/>添加菜品
          </a-button>
        </a-col>
      </a-row>
    </div>
    <a-list
      :grid="{ gutter: 16, column: 6 }"
      :loading="loading"
      :pagination="pagination"
      :dataSource="data"
    >
      <a-list-item slot="renderItem" slot-scope="item" key="item.title">
        <a-card hoverable style="width:100%;">
          <img
            alt="暂无菜品图片"
            :src="item.imgUrl ? item.imgUrl : noImgUrl"
            slot="cover"
            style="height:150px"
          >
          <template class="ant-card-actions" slot="actions">
            <!--  <a-icon type="setting"/> -->
            <a-icon type="edit" @click="showEditDrawers(item)"/>
            <!-- <a-icon type="ellipsis"/> -->
          </template>
          <a-card-meta :title="item.name" :description="item.describe?item.describe:'暂无描述'">
            <!-- <a slot="title">{{ item.name }}</a> -->
          </a-card-meta>
        </a-card>
      </a-list-item>
    </a-list>
    <addCommonDisheForm
      :visible="showAddDrawer"
      :spinning="addSpining"
      @close="showAddDrawers"
      @submit="onAddDishe"
      @gotoEdit="toEdit"
    ></addCommonDisheForm>
    <editCommonDisheForm
      :visible="showEditDrawer"
      :spinning="editSpining"
      :formData="editFormData"
      @close="showEditDrawers"
      @submit="onEditDishe"
    ></editCommonDisheForm>
  </div>
</template>
<script>
import addCommonDisheForm from '@/components/food/add-common-dishe-form'
import editCommonDisheForm from '@/components/food/edit-common-dishe-form'
import {
  getCommonDishe,
  addDishe,
  editDishe,
  getMenuById
} from '@/apis/common-dishe'
import noImg from '@/assets/images/noImg.jpg'

export default {
  mounted () {
    this.fetch({ search: this.keyword, ...this.pagination })
  },
  data () {
    return {
      keyword: '',
      data: [],
      pagination: {
        pageSize: 12,
        showTotal: total => `共${total}条`,
        current: 1,
        pageIndex: 1,
        onChange: (page, pageSize) => {
          this.pagination.current = page
          this.pagination.pageIndex = page
          this.pagination.pageSize = pageSize
          this.fetch({ search: this.keyword, ...this.pagination })
        }
      },
      loading: false,
      showAddDrawer: false,
      showEditDrawer: false,
      editFormData: null,
      addSpining: false,
      editSpining: false,
      noImgUrl: noImg
    }
  },
  components: {
    addCommonDisheForm,
    editCommonDisheForm
  },
  methods: {
    showAddDrawers () {
      this.showAddDrawer = !this.showAddDrawer
    },

    // 显示编辑页面
    showEditDrawers (item) {
      this.editFormData = null
      this.showEditDrawer = !this.showEditDrawer
      this.editSpining = true
      if (this.showEditDrawer) {
        getMenuById({ id: item.id }).then(res => {
          if (res.data.state === 1) {
            this.editFormData = item
            this.editSpining = false
            this.editFormData.componentData = res.data.attribute
          }
        })
      }
    },

    // 按菜品名称搜索
    onSearch () {
      this.fetch({ search: this.keyword, ...this.pagination })
    },

    // 获取菜品库数据
    fetch (params = {}) {
      this.loading = true
      getCommonDishe(params).then(res => {
        if (res.data.state === 1) {
          console.log(res)
          const pagination = { ...this.pagination }
          pagination.total = res.data.attribute.count
          this.loading = false
          this.data = res.data.attribute.rows
          this.pagination = pagination
        }
      })
    },

    // 去编辑
    toEdit (value) {
      let arr = value.split('_')
      let item = {
        id: arr[1],
        name: arr[0],
        imgUrl: arr[2],
        describe: arr[3],
        isEnable: arr[4] === 'true'
      }
      console.log(item)
      this.showAddDrawer = false
      this.showEditDrawers(item)
    },

    // 提交添加菜品的表单
    onAddDishe (formData, file) {
      this.addSpining = true
      let fd = new FormData()
      fd.append('list', formData)
      fd.append('file', file || null)
      addDishe(fd).then(res => {
        if (res.data.state === 1) {
          this.$message.success('菜品添加成功')
          this.pagination.pageIndex = 1
          this.fetch({ search: this.keyword, ...this.pagination })
        }
        this.addSpining = false
      })
    },

    // 提交编辑
    onEditDishe (formData, file) {
      console.log(formData)
      this.editSpining = true
      let fd = new FormData()
      fd.append('list', formData)
      fd.append('file', file || null)
      editDishe(fd).then(res => {
        if (res.data.state === 1) {
          this.$message.success('菜品编辑成功')
          this.pagination.pageIndex = 1
          this.fetch({ search: this.keyword, ...this.pagination })
        }
        this.editSpining = false
      })
    }
  }
}
</script>

<style lang="less">
.ant-list-item {
  .ant-list-item-content {
    .ant-card-body {
      padding: 20px;
    }
  }
}

.ant-card-meta-description {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.search-bar {
  padding-bottom: 10px;
}
</style>
